import styled from 'styled-components/macro';

import { container, containerTall } from 'styles/layout';
import { headingLower, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled.div`
  ${containerTall}
`;

export const Container = styled.div`
  ${container};
`;

export const List = styled.div`
  padding: 3px 13px;
`;

export const Description = styled.p`
  ${paragraph}

  border-bottom: 1px solid rgba(0,0,0,0.2);
  margin-top: 30px;
  text-align: left;

  & {
    padding-bottom: 20px;
  }

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const Subhead = styled.p`
  ${container}
  ${headingLower}

  font-weight: 700;
  margin: 10px auto;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;
